import type {
  DataPaginationResponseWithCount_ArtShortSerializer_ as AbonementExclusivesDataPaginationResponse,
  PaginationResponseWithCount_ArtShortSerializer_ as AbonementExclusivesResponse,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import { TagsType } from "../constants";

export const abonementExclusivesApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getAbonementExclusives: build.query<
      AbonementExclusivesDataPaginationResponse,
      { limit: number }
    >({
      query: ({ limit = 50 }) => ({
        url: "/foundation/api/arts/abonement-exclusives",
        params: { limit },
      }),
      transformResponse: (response: AbonementExclusivesResponse) => {
        return response.payload;
      },
      providesTags: result =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: TagsType.ART_SHORT_LIST as const,
                id,
              })),
              TagsType.ART_SHORT_LIST,
            ]
          : [TagsType.ART_SHORT_LIST],
    }),
  }),
});
